/**
 * What the page for individuals tells search engines — ONE copy, read by today's page
 * (src/pages/ForIndividuals.tsx) and its rebuild in the new design (src/design/pavilion/pages/for-individuals/), as
 * src/config/homeSeo.ts serves both home pages (PV4, design record §7b). Read by the guest chat's knowledge source
 * for "/for-individuals": each `title:` / `description:` stays on one line.
 */
export const FOR_INDIVIDUALS_CANONICAL_URL = 'https://prest0.ai/for-individuals';

/** The props both pages hand to <SeoHead>. */
export const FOR_INDIVIDUALS_SEO = {
  title: 'Legal Demystified with AI | prest0',
  description: 'Navigate the legal system with confidence. Understand contracts, draft demand letters, and analyze court documents with our consumer legal AI.',
  keywords: 'free legal AI, AI legal help, understand contracts AI, write demand letter AI, self-help legal AI, tenant rights AI',
  canonicalUrl: FOR_INDIVIDUALS_CANONICAL_URL,
} as const;
